import React, { useState } from 'react'
import SmartImage from '../SmartImage'
import { ContactContent, EachContact, EachFaq, FaqContent, RightContent } from './style'
import { BoldHeadingPri, BoldLg, RegMed, RegSm, } from '../CustomStyles'
import Colors from '../../Constant/Colors'
import { STYLES } from "../../Constant/Theme";
import images from '../../Constant/images'

const FaqsComponent = () => {
    const [faqs, setFaqs] = useState([
        {
            id: 0,
            title: "Is there a freetrial?",
            image: images.addressWhite,
            detail:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            isOPened: true,
        },
        {
            id: 1,
            title: "Is there a freetrial?",
            image: images.addressWhite,
            detail:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            isOPened: false,
        },
        {
            id: 2,
            title: "Is there a freetrial?",
            image: images.addressWhite,
            detail:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            isOPened: false,
        },
    ]);
    const handleFAQ = (id) => {
        let arr = [...faqs];
        arr.forEach((f) => {
            if (f.id === id) {
                f.isOPened = !f.isOPened;
            } else {
                f.isOPened = false;
            }
        });
        setFaqs(arr);
    };

    const [contacts] = useState([
        {
            id: 0,
            image: images.addressWhite,
            detail:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            action: () => { window.open('https://www.google.com/maps?q=1600+Amphitheatre+Parkway,+Mountain+View,+CA') }
        },
        {
            id: 1,
            image: images.callWhite,
            detail: "+1234567890",
            action: () => { window.location.href = 'tel:+1234567890' }
        },
        {
            id: 2,
            image: images.mailWhite,
            detail: "abc@gmail.com",
            action: () => { window.location.href = 'mailto:abc@gmail.com' }
        },
    ]);
    const styles = {
        imgDiv: {
            ...STYLES.spaceBetween,
            width: "100%",
            paddingTop: 15,
        },
        img: isOPened => ({
            width: 20,
            height: 20,
            transform: !isOPened ? "rotate(180deg)" : "",
            transition: "transform 500ms ease",
            marginTop: -15
        })
    }




    return (
        <RightContent>
            <ContactContent>
                <BoldLg style={{ color: Colors.whiteThemeColor }}>Contact</BoldLg>
                {contacts?.map((each) => (
                    <EachContact key={each?.id} onClick={() => each.action()} style={{ cursor: 'pointer' }}>
                        <SmartImage
                            src={each?.image}
                            style={{ width: 20, height: 20, marginRight: 10 }}
                        />
                        <RegMed style={{ color: Colors.whiteThemeColor }}>{each?.detail}</RegMed>
                    </EachContact>
                ))}
            </ContactContent>
            <BoldHeadingPri style={{ marginTop: 20 }}>FAQs</BoldHeadingPri>
            <FaqContent>
                {faqs?.map((each) => (
                    <EachFaq key={each?.id} isOpened={each?.isOPened}>
                        <div
                            style={styles.imgDiv}
                            onClick={() => handleFAQ(each?.id)}
                        >
                            <BoldLg >{each?.title}</BoldLg>
                            <SmartImage
                                src={images.upBorder}
                                style={styles.img(each?.isOPened)}
                            />
                        </div>
                        <RegSm style={{ color: Colors.lightTxt, marginTop: 10 }}>{each?.detail}</RegSm>
                    </EachFaq>
                ))}
            </FaqContent>
        </RightContent>
    )
}

export default FaqsComponent